<template>
  <div class="home">
    <div class="productsTabBox">
      <div class="productsTab" :class="store.state.isPc ? 'Pc' : ''">
        <div
          class="tabItem"
          v-for="(item, index) in list"
          v-bind:key="item.id"
          @click="scrollToElement(item.id)"
          :id="'tab' + item.id"
          :ref="itemRefs[index]"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="imageBox">
      <img src="@/assets/images/背景文字1.png" class="bgcfont" alt="" />
      <template v-for="item in list" v-bind:key="item.id">
        <div
          class="imageItem"
          :class="`${item.title == 'PF-650' ? 'pf650':''} ${store.state.isPc ? '' : 'imageItemPhone'}`"
          v-if="item.id != 5"
          :id="item.id"
          @click="toDetail(item.id)"
        >
          <div class="itemTitle">{{ item.title }}</div>
          <div class="itemSecTitle">
            {{ store.state.language == "cn" ? item.Subtitle : item.name }}
          </div>

          <img
            class="mainImage"
            :class="`${store.state.isPc ? 'mainImagePc' : ''} ${item.title == 'PF-650' ? 'pf650':''}`"
            :src="getImagePath(item.mainImage)"
          />
          <div class="secBox1 secBox" v-if="!store.state.isPc">
            <img :src="getImagePath(item.oneImage)" alt="" />
            <img :src="getImagePath(item.twoImage)" alt="" />
            <img :src="getImagePath(item.threeImage)" alt="" />
          </div>
          <div class="secBox2 secBox" v-if="store.state.isPc">
            <img :src="getImagePath(item.oneImage)" alt="" />
            <img :src="getImagePath(item.twoImage)" alt="" />
            <img :src="getImagePath(item.threeImage)" alt="" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src
import products from "@/assets/json/products.json";
import { ref, onMounted } from "vue";
import images from "@/utils/images.ts";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const router = useRouter();
const store = useStore();

var { getImagePath } = images;
// const tabItems = ref();
var list = ref(products.products);
const itemRefs = list.value.map(() => ref(null));

const scrollToElement = (id) => {
  if (id == 5) {
    toDetail(id);
  } else {
    var a = document.getElementById(`${id}`);
    a.scrollIntoView({
      behavior: "smooth", // 平滑滚动
      block: "center", // 将目标元素的顶部与视口顶部对齐
    });
  }
};

const toDetail = (id) => {
  router.push({ path: "/ProductItem", query: { id } });
};

onMounted(async () => {});
</script>

<style lang="scss" scoped>
.home {
  width: 100%;

  .productsTabBox {
    width: 100%;
    height: 2rem;
    background-color: #fff;
  }

  .productsTab {
    width: 100%;
    height: 2rem;
    display: flex;
    margin: 0 auto;
    overflow: auto;
    max-width: 75rem;
    // justify-content: center;
    padding: 0 0.8125rem;
    box-sizing: border-box;
    justify-content: space-around;
    // &.Pc {
    //   padding-left: 12.8125rem;
    // }

    .tabItem {
      width: 6rem;
      height: 2rem;
      font-size: 1.5rem;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 2rem;
      cursor: pointer;
      text-align: center;
      box-sizing: border-box;

      &:hover {
        color: #ff000d;
        border-bottom: 0.125rem solid #ff000d;
      }
    }
  }
  .imageBox {
    width: 100%;
    // height: calc(100vh - 12.125rem);
    // overflow-y: auto;
    // overflow-x: hidden;
    margin: 0 auto;
    // max-width: 75rem;
    position: relative;
    margin-bottom: 1.5rem;

    .bgcfont {
      position: absolute;
      z-index: 0;
      width: 6.8125rem;
      // height: 94.5rem;
      height: 100%;
    }
    .imageItem.pf650{
      height: 28.5rem;  
    }

    .imageItem {
      // width: 100%;
      max-width: 75rem;
      height: 22.5rem;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      border-bottom: 0.0625rem solid #f0f0f0;

      .itemTitle {
        font-family: GenSenRoundedTW-B;
        font-size: 2.5rem;
        color: #ff000d;
        letter-spacing: 0;
        font-weight: 700;
        position: absolute;
        top: 4.875rem;
        left: 3.625rem;

        &.Pc {
          font-size: 3.125rem;
          color: #ff000d;
          letter-spacing: 0;
          font-weight: 700;
        }
      }

      .itemSecTitle {
        font-family: SourceHanSansCN-Regular;
        font-size: 1.5rem;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        top: 7.875rem;
        position: absolute;
        left: 3.625rem;
      }

      .mainImage {
        width: 39.375rem;
        height: 100%;
        position: relative;
      }
      .mainImagePc {
        height: 19.25rem;
        margin-top: 2.8125rem;
      }
      .mainImagePc.pf650{
        margin-top: 6.8125rem;
      }
      .secBox {
        display: flex;
        position: absolute;
        justify-content: space-between;
      }

      .secBox1 {
        flex-direction: column;
        top: 0.3125rem;
        left: 36.25rem;
        width: 8.875rem;
        height: 21.3125rem;
        img {
          width: 8.875rem;
          height: 5.1875rem;
        }
      }

      .secBox2 {
        width: 33.25rem;
        height: 5.875rem;
        top: 9.75rem;
        left: 41.4375rem;
        img {
          width: 10rem;
          height: 5.875rem;
        }
      }
    }

    .imageItemPhone {
      max-width: 46.875rem;
      margin: 1rem auto;
    }
  }
}
</style>
